export const allergyTypeOptions = [
  { label: 'Drug', value: 'drug' },
  { label: 'Food/Other', value: 'food' },
]

export const allergyTypeLabels = allergyTypeOptions.reduce<Record<string, string>>((acc, curr) => {
  return { ...acc, [curr.value]: curr.label }
}, {})
